import { ConsentType } from '@csp/dmdp-api-user-dto';
import { GenericContentService } from '../../service/GenericContentService';
import { ConsentVideoEntry } from '../../consent-video/model/ConsentVideoEntry';
import { ConsentVideoEntryMapper } from '../../consent-video/mapper/ConsentVideoEntryMapper';

export const getGenericConsentVideo = (consentType: ConsentType, version: string): ConsentVideoEntry => {
  const consentVideo = GenericContentService.getConsentVideo(consentType, version);
  return ConsentVideoEntryMapper.from(consentVideo);
};
